import './App.css';
import { HomePage, ProjectsPage, ContactPage, PricingPage } from './pages';
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={ <HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        
      </Routes>
    </div>
  );
}

export default App;
